"use client"

import { useEffect } from "react"

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error(error)
  }, [error])
  return (
    <div>
      Server Error occurred.
      <br />
      <button type="button" onClick={() => reset()}>
        Try again.
      </button>
    </div>
  )
}
